export default {
  path: '/wiki',
  name: 'wiki',
  meta: {
    icon: 'ios-book',
    access: 'menu_wiki',
    title: '知识库'
  },
  component:  () => import('@/views/Main.vue'),
  children: [
    {
      path: 'docs',
      name: 'docs',
      meta: {
        icon: 'ios-folder',
        access: 'menu_wiki_folder',
        title: '知识库'
      },
      component: () => import('@/views/wiki/wiki.vue')
    },
    {
      path: 'docs/edit/:sid',
      name: 'docs-edit',
      meta: {
        icon: 'ios-folder',
        access: 'menu_wiki_folder',
        title: '知识库'
      },
      component: () => import('@/views/wiki/edit.vue')
    },
  ]
}
